import { ReactNode } from 'react';

import { Flex } from '@project44/manifest-ds';

const style = {
  flex: 1,
  padding: '$large',
  position: 'relative',
  '&::before': {
    content: '',
    background: '$background-top-nav',
    position: 'absolute',
    top: 0,
    left: 0,
    height: '170px',
    width: '100%',
    zIndex: '-1',
  },
};

interface IPageLayout {
  children: ReactNode;
  renderBanner?: () => JSX.Element | null;
}

function PageLayout({ children, renderBanner = () => null }: IPageLayout) {
  return (
    <Flex orientation="vertical" css={{ height: '100%' }}>
      {renderBanner()}
      <Flex data-testid="page-layout" orientation="vertical" css={style}>
        {children}
      </Flex>
    </Flex>
  );
}

export default PageLayout;
